import { AvField, AvForm } from "availity-reactstrap-validation";
import axios from "axios";
import "flatpickr/dist/themes/material_blue.css";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Bounce, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Button, Card, CardBody, Col, Label, Row } from "reactstrap";
import api from "../../services/api";

const AddCourseRegistration = () => {
    const navigate = useNavigate();
    document.title = "Technical Hub | AddCourseRegistration";

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const backendImgUrl = process.env.REACT_APP_BACKEND_IMAGE_URL;
    const allowedRegex = /^[a-zA-Z0-9\s.-]*$/;


    const cleanInput = (value) => {
        // Allow letters, numbers, spaces, hyphens, dots
        value = value.replace(/[^a-zA-Z0-9\s.-]/g, "");

        // No leading spaces
        value = value.replace(/^\s+/g, "");

        // Limit to 25 chars
        return value.slice(0, 25);
    };

    const [courses, setCourses] = useState([]);
    const [technologies, setTechnologies] = useState([]);
    const [selectedTechnology, setSelectedTechnology] = useState(null);
    const [technologyLogoDetails, setTechnologyLogoDetails] = useState([]);
    const [selectedTechnologyLogo, setSelectedTechnologyLogo] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [addedby, setAddedBy] = useState("");

    // State variables for form fields
    const [programName, setProgramName] = useState("");
    const [appProgram, setAppProgram] = useState("");
    const [fee, setFee] = useState("");
    const [seats, setSeats] = useState("");
    const [description, setDescription] = useState("");
    const [note, setNote] = useState("");
    const [eligibleRollNos, setEligibleRollNos] = useState("");
    const [eligibleYears, setEligibleYears] = useState();
    const [selectedEligibleYears, setSelectedEligibleYearss] = useState([]);
    const [selectedGender, setSelectedGender] = useState(null);
    const [passoutYears, setPassoutYears] = useState();
    const [selectedPassoutYears, setSelectedPassoutYears] = useState(null);
    const [programNames, setProgramNames] = useState();
    const [selectedProgramNames, setSelectedProgramNames] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedRegistrationStatus, setSelectedRegistrationStatus] = useState(null);
    const [batchTag, setBatchTag] = useState("");
    const [selectedScholarType, setSelectedScholarType] = useState(null);
    const [noOfTerms, setNoOfTerms] = useState("");
    const [termFeeDetails, setTermFeeDetails] = useState([
        { term_name: "", amount: 0, status: "", endDate: "" }
    ]);
    const [termNameOptions, setTermNameOptions] = useState([]);
    const [courseStartDate, setCourseStartDate] = useState(null);
    const [courseEndDate, setCourseEndDate] = useState(null);
    const [registrationStartDate, setRegistrationStartDate] = useState(null);
    const [registrationEndDate, setRegistrationEndDate] = useState(null);

    const [mentors, setMentors] = useState("");
    const [supportMentors, setSupportMentors] = useState("");
    const [syllabus, setSyllabus] = useState(null);
    const [certifications, setCertifications] = useState([
        { name: "", logo: "" }
    ]);

    const [certificationOptions, setCertificationOptions] = useState([]);
    const [order, setOrder] = useState("");

    const [colleges, setColleges] = useState([]);
    const [selectedColleges, setSelectedColleges] = useState([]);
    const [branches, setBranches] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);

    const [cashierNames, setCashierNames] = useState([]);
    const [selectedCashiers, setSelectedCashiers] = useState([]);
    const [trainers, setTrainers] = useState([]);
    const [selectedMentors, setSelectedMentors] = useState([]);
    const [selectedSupportMentors, setSelectedSupportMentors] = useState([]);


    useEffect(() => {
        const curr_user = JSON.parse(localStorage.getItem('authUser'));
        if (curr_user) {
            setAddedBy(curr_user.first_name);
        }
        getCourses();
        getPassoutYears();
        getCertifications();
        getColleges();
        getBranches();
        getCashierNames();

        const generatedTerms = [];
        for (let i = 1; i <= parseInt(noOfTerms, 10); i++) {
            generatedTerms.push({ value: `Term ${i}`, label: `Term ${i}` });
        }
        setTermNameOptions(generatedTerms);
    }, [noOfTerms]);

    const getCourses = async () => {
        try {
            const response = await axios.get(`${backendUrl}get-courses`);
            if (response.status === 200) {
                setCourses(response.data);
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        const getTechnologies = async () => {
            if (selectedCourse?.value) {
                try {
                    const response = await axios.post(`${backendUrl}get-technology-by-course-id`, {
                        "course_id": selectedCourse.value
                    });
                    if (response.status === 200) {
                        setTechnologies(response.data);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        }
        getTechnologies();
    }, [selectedCourse, backendUrl]);

    useEffect(() => {
        const getCourseProgramNames = async () => {
            if (selectedCourse?.value) {
                try {
                    const response = await axios.post(`${backendUrl}get-by-filters`, {
                        "course_id": selectedCourse.value,
                        "passout_year": selectedPassoutYears.value
                    });
                    if (response.status === 200) {
                        setProgramNames(response.data.data);
                        setSelectedProgramNames(null);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        }
        getCourseProgramNames();
    }, [selectedCourse, selectedPassoutYears, backendUrl]);


    useEffect(() => {
        const getTrainersNames = async () => {
            if (selectedTechnology?.value) {
                try {
                    const response = await axios.post(`${backendUrl}get-users-by-technology`,
                        {
                            "technology_ids": [selectedTechnology.value]
                        }
                    )
                    if (response.status === 200) {
                        setTrainers(response.data);
                    }
                }
                catch (err) {
                    console.log(err);

                }
            }
        }
        getTrainersNames();
    }, [selectedTechnology]);

    useEffect(() => {
        const getTechnologyIconDetails = async () => {
            if (selectedTechnology?.value) {
                try {
                    const response = await axios.get(`${backendUrl}get-technology-icon/${selectedTechnology.value}`);
                    if (response.status === 200) {
                        setTechnologyLogoDetails(response.data);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        }
        getTechnologyIconDetails();
    }, [selectedTechnology, backendUrl]);

    const getPassoutYears = async () => {
        try {
            const response = await axios.get(`${backendUrl}get-passout_year`);
            if (response.status === 200) {
                setPassoutYears(response.data);
                setEligibleYears(response.data);
            }
        } catch (err) {
            console.log(err);
        }
    }


    const getColleges = async () => {
        try {
            const response = await axios.get(`${backendUrl}get-colleges`)
            if (response.status === 200) {
                setColleges(response.data.colleges);
            }
        }
        catch (err) {
            console.log(err)
        }
    }


    const getBranches = async () => {
        try {
            const response = await axios.get(`${backendUrl}get-branches`);
            if (response.status === 200) {
                // flatten all _id values into a single array of strings
                let arrayofBranches = response.data.branches.flatMap((ele) => {
                    if (Array.isArray(ele._id)) {
                        return ele._id; // spread array
                    } else if (typeof ele._id === "string") {
                        return [ele._id]; // wrap string in array
                    } else {
                        return []; // skip null/undefined
                    }
                });

                // Optional: remove duplicates + trim spaces
                arrayofBranches = [...new Set(arrayofBranches.map(b => b.trim()))];

                setBranches(arrayofBranches);
            }
        } catch (err) {
            console.log(err);
        }
    };


    const getCashierNames = async () => {
        try {
            const response = await api.get(`${backendUrl}get-cashiers`);
            if (response.status === 200) {
                console.log("Cashier Names:", response.data.data);
                setCashierNames(response.data.data);
            }
        } catch (err) {
            console.log(err);
        }
    };


    const handleTermFeeChange = (index, field, value) => {
        const newDetails = [...termFeeDetails];

        if (field === "amount") {
            newDetails[index][field] = Number(value);   // amount → number
        } else if (field === "status") {
            newDetails[index][field] = Number(value);   // status → number (1 or 0)
        } else {
            newDetails[index][field] = value;           // everything else → as is
        }

        setTermFeeDetails(newDetails);
    };


    const addTermFeeField = () => {
        // Check if the "No Of Terms" field is a valid number
        if (!noOfTerms || parseInt(noOfTerms, 10) <= 0) {
            toast.error("Please specify the number of terms before adding fee details.");
            return;
        }

        // Check if the number of current terms has reached the limit
        if (termFeeDetails.length >= parseInt(noOfTerms, 10)) {
            toast.error(`You can't add more than ${noOfTerms} terms.`);
            return;
        }

        //  Add the new validation check for sequential entry
        const lastTerm = termFeeDetails[termFeeDetails.length - 1];
        if (termFeeDetails.length > 0 && (!lastTerm.term_name || !lastTerm.amount)) {
            toast.error("Please fill out the current term's details before adding a new one.");
            return;
        }

        // If all validations pass, add a new term fee detail row
        setTermFeeDetails([
            ...termFeeDetails,
            { term_name: "", amount: 0, status: "", endDate: "" }
        ]);
    };

    const removeTermFeeField = (index) => {
        const newDetails = [...termFeeDetails];
        newDetails.splice(index, 1);
        setTermFeeDetails(newDetails);
    };


    const getCertifications = async () => {
        try {
            const response = await axios.get(`${backendUrl}get-certifications`);
            if (response.status === 200) {
                setCertificationOptions(response.data);
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        if (!selectedTechnology?.value) return;
        if (technologyLogoDetails.length === 0) return;

        const autoLogo = technologyLogoDetails.find(
            item =>
                item.technology === selectedTechnology.value ||
                item.technology_id === selectedTechnology.value ||
                item._id === selectedTechnology.value
        );

        if (autoLogo) {
            setSelectedTechnologyLogo({
                label: autoLogo.technology_name,
                value: autoLogo.technology_icon
            });
        }
    }, [technologyLogoDetails, selectedTechnology]);


    const handleCertificationChange = (index, value) => {
        const selected = certificationOptions.find(
            (c) => c.certification_name === value
        );

        const updated = [...certifications];
        updated[index] = {
            name: selected?.certification_name || "",
            logo: selected?.certification_icon || ""
        };
        setCertifications(updated);
    };

    const handleAddCertification = () => {
        // Get the last certification object in the array
        const lastCert = certifications[certifications.length - 1];
        // Check if the last certification's name and logo are filled
        if (!lastCert || (lastCert.name && lastCert.logo)) {
            // If the last one is filled (or if it's the first one being added),
            // add a new, empty certification object to the state.
            setCertifications([...certifications, { name: "", logo: "" }]);
        } else {
            // If the last one is not filled, show an error toast message.
            toast.error("Please fill out the current certification before adding a new one.");
        }
    };





    const handleRemoveCertification = (index) => {
        const updated = [...certifications];
        updated.splice(index, 1);
        setCertifications(updated);
    };


    console.log(certifications)
    const courseOptions = courses?.map((ele) => {
        return { label: ele.course_name, value: ele._id }
    });

    const handleSelectedCourse = (selectedOption) => {
        setSelectedCourse(selectedOption);
        setSelectedTechnology(null);
        setSelectedProgramNames(null);
        setProgramNames(null);

    };

    const technologyOptions = technologies?.map((ele) => {
        return { label: ele.technology_name, value: ele._id }
    });

    const handleSelectedTechnology = (selectedOption) => {
        setSelectedTechnology(selectedOption);
        setSelectedTechnologyLogo(null); // reset first
        setSelectedProgramNames(null);
    };




    const handleAppProgram = (e) => {
        setAppProgram(cleanInput(e.target.value));
    };



    const technologyLogoOptions = technologyLogoDetails?.map((ele) => ({
        label: ele.technology_name,
        value: ele.technology_icon
    }));

    const scholorTypeOptions = [
        {
            options: [
                { label: "Day Scholar", value: "day scholar" },
                { label: "Hosteller", value: "hosteller" },
                { label: "All", value: "All" },
            ]
        }
    ];

    const handleSelectedScholarType = (selectedGroup) => {
        setSelectedScholarType(selectedGroup);
    };

    // 1. Sanitize Input (Handling Pasted Text)
    const handleEligibleRollNos = (e) => {
        let value = e.target.value;

        // Remove ALL spaces
        value = value.replace(/\s/g, "");

        // Remove anything that is NOT a Letter, Number, or Comma
        value = value.replace(/[^a-zA-Z0-9,]/g, "");

        setEligibleRollNos(value);
    };

    // 2. Block Keystrokes (Preventing Typing)
    const blockInvalidRollNoKeys = (e) => {
        // Allow standard control keys (Backspace, Tab, Enter, Arrows, Delete)
        if (["Backspace", "Tab", "Enter", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)) {
            return;
        }

        // Allow Copy/Paste (Ctrl+C, Ctrl+V, Command+C, Command+V)
        if ((e.ctrlKey || e.metaKey) && ["c", "v", "a"].includes(e.key.toLowerCase())) {
            return;
        }

        // Strictly check the key pressed. 
        // If it is NOT (a-z, A-Z, 0-9, or comma), block it.
        if (!/^[a-zA-Z0-9,]$/.test(e.key)) {
            e.preventDefault();
        }
    };
    // Block Keystrokes for Description/Note (Prevent Special Chars)
    const blockInvalidTextKeys = (e) => {
        if (["Backspace", "Tab", "Enter", "ArrowLeft", "ArrowRight", "Delete", " "].includes(e.key)) {
            return;
        }
        if ((e.ctrlKey || e.metaKey) && ["c", "v", "a"].includes(e.key.toLowerCase())) {
            return;
        }
        if (!/^[a-zA-Z0-9, ]$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleDescription = (e) => {
        let value = e.target.value;

        // Allow letters, numbers, commas, spaces
        value = value.replace(/[^a-zA-Z0-9, ]/g, "");
        setDescription(value);
    }

    const handleNote = (e) => {
        let value = e.target.value;
        // Allow letters, numbers, commas, spaces
        value = value.replace(/[^a-zA-Z0-9, ]/g, "");
        setNote(value);
    };


    const cashierOptions = cashierNames?.map((ele) => {
        return { label: `${ele.first_name} - ${ele.college}`, value: ele.first_name };
    });

    const handleSelectedCashiers = (selectedGroup) => {
        setSelectedCashiers(selectedGroup);
    };

    const genderOptions = [
        {
            options: [
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Any", value: "any" },
            ]
        }
    ];

    const handleSelectedGender = (selectedGroup) => {
        setSelectedGender(selectedGroup);
    };

    const passoutYearsOptions = passoutYears?.map((ele) => {
        return { label: ele.label, value: ele.value };
    });



    const programNameOptions = programNames?.map((ele) => {
        return { label: ele.program_name, value: ele.program_name };
    });



    const handleProgramName = (option) => {
        setSelectedProgramNames(option)
    }

    const handlePassoutYears = (selectedGroup) => {
        setSelectedPassoutYears(selectedGroup);
        setSelectedProgramNames(null);
        setProgramNames(null);
    };



    const eligiblePasoutYearsOptions = eligibleYears?.map((ele) => {
        return { label: ele.label, value: ele.value }
    })


    const handleEligiblePassoutYears = (selectedOption) => {
        setSelectedEligibleYearss(selectedOption);
    }


    const statusOptions = [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 }
    ];

    const registrationStatusOptions = [
        { label: "Open", value: 1 },
        { label: "Closed", value: 0 }
    ];


    const mentorOptions = trainers.map(t => ({
        label: t.first_name,
        value: t.first_name
    }));

    const supportMentorOptions = trainers.map(t => ({
        label: t.first_name,
        value: t.first_name
    }));
    const handleMentors = (selected) => {
        setSelectedMentors(selected);
    };

    const handleSupportMentors = (selected) => {
        setSelectedSupportMentors(selected);
    };



    const handleSelectedStatus = (option) => {
        setSelectedStatus(option);
    };
    const handleSelectedRegistrationStatus = (option) => {
        setSelectedRegistrationStatus(option)
    }

    const collegeOptions = colleges?.map((ele) => {
        return { label: ele._id, value: ele._id }
    });


    const handleSelectedColleges = (option) => {
        setSelectedColleges(option)
    }



    const branchOptions = branches?.map((ele => {
        return { label: ele, value: ele }
    }))

    const handleSelectedBranches = (option) => {
        setSelectedBranches(option)
    }

    useEffect(() => {
        console.log(branches)
    }, [branches])


    const formatLocalDate = (date) => {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0];
    };


    // ... (previous useEffect)
    useEffect(() => {
        // ... (previous code)

        // Add this section to dynamically generate term names
        const generatedTerms = [];
        for (let i = 1; i <= parseInt(noOfTerms, 10); i++) {
            generatedTerms.push({ value: `Term ${i}`, label: `Term ${i}` });
        }
        setTermNameOptions(generatedTerms);

    }, [selectedCourse, backendUrl, noOfTerms]);

    useEffect(() => {
        console.log(selectedColleges)
    }, [selectedColleges])

    //final submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        // ---------- REQUIRED FIELDS ----------
        if (!selectedCourse?.value) return toast.error("Please select a course.");
        if (!selectedTechnology?.value) return toast.error("Please select a technology.");
        if (selectedCashiers.length === 0)
            return toast.error("Please select cashier names.");
        if (!selectedProgramNames) return toast.error("Program name is required.");
        if (!fee) return toast.error("Fee is required.");
        if (!seats) return toast.error("Seats are required.");
        if (!noOfTerms) return toast.error("No of terms is required.");
        if (!selectedGender) return toast.error("Gender is required.");
        // if (!selectedScholarType) return toast.error("Scholar Type is required.");
        if (!selectedPassoutYears) return toast.error("Passout Year is required.");
        if (!registrationStartDate) return toast.error("Registration Start Date is required.");
        if (!registrationEndDate) return toast.error("Registration End Date is required.");
        if (!courseStartDate) return toast.error("Course Start Date is required.");
        if (!courseEndDate) return toast.error("Course End Date is required.");
        if (!selectedStatus) return toast.error("Payment Status is required.");
        if (!selectedRegistrationStatus) return toast.error("Registration Status is required.");

        // ---------- TERM VALIDATION ----------
        if (parseInt(noOfTerms) !== termFeeDetails.length) {
            return toast.error("The number of terms must match the number of term fee details.");
        }

        const totalTermAmount = termFeeDetails.reduce((sum, t) => sum + Number(t.amount || 0), 0);

        if (Number(fee) !== totalTermAmount) {
            return toast.error(`Total term amount (${totalTermAmount}) must equal the Fee (${fee}).`);
        }

        // ---------- DATE VALIDATIONS ----------
        const cStart = new Date(courseStartDate);
        const cEnd = new Date(courseEndDate);
        const rStart = new Date(registrationStartDate);
        const rEnd = new Date(registrationEndDate);

        // Registration End > Registration Start
        if (rEnd <= rStart) {
            return toast.error("Registration End Date must be GREATER than Registration Start Date.");
        }

        // Course Start > Registration End
        if (cStart <= rEnd) {
            return toast.error("Course Start Date must be GREATER than Registration End Date.");
        }

        // Course End > Course Start
        if (cEnd <= cStart) {
            return toast.error("Course End Date must be GREATER than Course Start Date.");
        }


        // ---------- BUILD FORMDATA ----------
        const formData = new FormData();

        formData.append("course", selectedCourse.value);
        formData.append("technology", selectedTechnology.value);
        formData.append("technology_icon", selectedTechnologyLogo?.value || "");
        formData.append("program_name", selectedProgramNames?.value);
        formData.append("app_program", "testing");
        formData.append("fee", fee);
        formData.append("seats", seats);
        formData.append("gender", selectedGender?.value);
        formData.append("passout_year", selectedPassoutYears?.value);
        formData.append("scholar_type", selectedScholarType?.value || "");
        formData.append("no_of_terms", noOfTerms);
        formData.append("status", selectedStatus.value); // payment status
        formData.append("registration_status", selectedRegistrationStatus.value);

        // dates
        formData.append("course_start_date", formatLocalDate(cStart));
        formData.append("course_end_date", formatLocalDate(cEnd));
        formData.append("registration_start_date", formatLocalDate(rStart));
        formData.append("registration_end_date", formatLocalDate(rEnd));


        // JSON fields
        formData.append("eligible_rollNos", JSON.stringify(eligibleRollNos.split(',').map(r => r.trim()).filter(r => r)));
        formData.append("eligible_college", JSON.stringify(selectedColleges.map(c => c.value)));
        formData.append("eligible_branch", JSON.stringify(selectedBranches.map(b => b.value)));
        formData.append("eligible_passout_year", JSON.stringify(selectedEligibleYears.map(y => y.value)));
        formData.append("term_fee_details", JSON.stringify(termFeeDetails));
        formData.append("cashier_names", JSON.stringify(selectedCashiers.map(c => c.value)));

        // Certifications
        const certificationsData = certifications
            .filter(c => c.name && c.logo)
            .map(c => ({ name: c.name, logo: c.logo }));

        formData.append("certifications", JSON.stringify(certificationsData));

        // File
        if (syllabus) formData.append("syllabus", syllabus);

        formData.append("description", description || "");
        formData.append("note", note || "");
        formData.append("added_by", addedby || "");

        // DEBUG
        console.log("---- FORM DATA ----");
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }

        // ---------- API CALL ----------
        try {
            const response = await api.post(`${backendUrl}create-course-registration`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.status === 201) {
                toast.success("Course registration created successfully!");
                setTimeout(() => navigate("/course-registrations-list"), 1200);
            }
        } catch (err) {
            console.error("Submit Error:", err);
            toast.error(err.response?.data?.message || "Something went wrong!");
        }
    };


    return (
        <React.Fragment>
            <Row>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Bounce}
                />
                <Col xl="12">
                    <Card>
                        <CardBody>
                            <h4 className="card-title">ADD Course Registration Data</h4>
                            <AvForm className="needs-validation" onValidSubmit={handleSubmit}>
                                <Row>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="course">Select Course <span className="text-danger">*</span></Label>
                                            <Select
                                                value={selectedCourse}
                                                onChange={handleSelectedCourse}
                                                options={courseOptions}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="technology">Select Technology <span className="text-danger">*</span></Label>
                                            <Select
                                                value={selectedTechnology}
                                                onChange={handleSelectedTechnology}
                                                options={technologyOptions}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="3">
                                        <div className="mb-4">
                                            <Label htmlFor="technology">
                                                Technology Logo <span className="text-danger">*</span>
                                            </Label>
                                            <Select
                                                value={selectedTechnologyLogo}
                                                options={technologyLogoOptions}
                                                isDisabled={true} // user cannot change manually
                                            />
                                        </div>
                                    </Col>

                                    {/* Separate preview image column */}
                                    <Col md="1">
                                        {selectedTechnologyLogo?.value && (
                                            <img
                                                src={`${backendImgUrl}technology-icons/${selectedTechnologyLogo.value}`}
                                                alt={selectedTechnologyLogo.label}
                                                style={{ width: "40px", height: "40px", objectFit: "contain" }}
                                                className="me-2 mt-4"
                                            />
                                        )}
                                    </Col>



                                </Row>

                                <Row>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="passout-year">Passout Year <span className="text-danger">*</span></Label>
                                            <Select
                                                value={selectedPassoutYears}
                                                options={passoutYearsOptions}
                                                onChange={handlePassoutYears}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="passout-year">Select Program Name <span className="text-danger">*</span></Label>
                                            <Select
                                                value={selectedProgramNames}
                                                options={programNameOptions}
                                                onChange={handleProgramName}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="fee">Fee <span className="text-danger">*</span></Label>
                                            <AvField
                                                name="fee"
                                                placeholder="Enter Fee"
                                                type="number"
                                                className="form-control"
                                                id="fee"
                                                value={fee}
                                                onChange={(e) => {
                                                    let val = e.target.value;
                                                    // Remove non-digits
                                                    val = val.replace(/[^0-9]/g, "");
                                                    // Optional: prevent leading zeros
                                                    val = val.replace(/^0+/, "");
                                                    setFee(val);
                                                }}
                                                onKeyDown={(e) => {
                                                    // Block minus, decimal, etc.
                                                    if (
                                                        ["-", "+", ".", "e", "E"].includes(e.key)
                                                    ) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />

                                        </div>
                                    </Col>

                                    {/* <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="app-program">
                                                App Program <span className="text-danger">*</span>
                                            </Label>

                                            <AvField
                                                name="app-program"
                                                placeholder="Enter App Program"
                                                type="text"
                                                className="form-control"
                                                id="app"
                                                value={appProgram}
                                                onChange={handleAppProgram}

                                                onKeyDown={(e) => {
                                                    const key = e.key;
                                                    if (!allowedRegex.test(key) && key.length === 1) {
                                                        e.preventDefault();
                                                    }
                                                }}

                                                onPaste={(e) => {
                                                    const paste = e.clipboardData.getData("text");
                                                    if (!allowedRegex.test(paste)) {
                                                        e.preventDefault();
                                                    }
                                                }}

                                                maxLength="25"
                                            />

                                        </div>
                                    </Col> */}

                                    {/* <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="batch-tag">Batch Tag</Label>
                                            <AvField
                                                name="batch-tag"
                                                placeholder="Enter Batch Tag"
                                                type="text"
                                                className="form-control"
                                                id="batch"
                                                value={batchTag}
                                                onChange={(e) => setBatchTag(e.target.value)}
                                            />
                                        </div>
                                    </Col> */}

                                </Row>

                                <Row>

                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="seats">Seats <span className="text-danger">*</span></Label>
                                            <AvField
                                                name="seats"
                                                placeholder="Enter Seats"
                                                type="number"
                                                className="form-control"
                                                id="seats"
                                                value={seats}
                                                onChange={(e) => {
                                                    let val = e.target.value;
                                                    // Remove anything that is NOT digits (0–9)
                                                    val = val.replace(/[^0-9]/g, "");
                                                    // Optional: remove leading zeros
                                                    val = val.replace(/^0+/, "");
                                                    setSeats(val);
                                                }}
                                                onKeyDown={(e) => {
                                                    // Block invalid keys like -, +, ., e, E
                                                    if (["-", "+", ".", "e", "E"].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />

                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="terms">No Of Terms <span className="text-danger">*</span></Label>
                                            <AvField
                                                name="terms"
                                                placeholder="Enter No of Terms"
                                                type="number"
                                                className="form-control"
                                                id="terms"
                                                min={1}
                                                max={10}
                                                value={noOfTerms}
                                                onChange={(e) => setNoOfTerms(e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="gender">Gender <span className="text-danger">*</span></Label>
                                            <Select
                                                value={selectedGender}
                                                options={genderOptions}
                                                onChange={handleSelectedGender}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>

                                    {/* <Col md="4">
                                        <div className="mb-4">
                                            <Label htmlFor="scholar-type">Scholar Type <span className="text-danger">*</span></Label>
                                            <Select
                                                value={selectedScholarType}
                                                options={scholorTypeOptions}
                                                onChange={handleSelectedScholarType}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col> */}
                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="roll-nos">Eligible Roll Nos</Label>
                                            <AvField
                                                tag="textarea"
                                                name="eligible_rollnos"
                                                id="roll-nos"
                                                rows="4"
                                                placeholder="Enter roll numbers separated by commas (e.g. 101,102)"
                                                className="form-control"
                                                value={eligibleRollNos}
                                                onChange={handleEligibleRollNos}       // Cleans text after input
                                                onKeyDown={blockInvalidRollNoKeys}     // Blocks invalid keys before input
                                                style={{
                                                    resize: "none",
                                                    overflowY: "auto",
                                                    overflowX: "hidden",
                                                    whiteSpace: "pre-wrap"
                                                }}
                                            />
                                        </div>
                                    </Col>

                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="colleges">Eligible Colleges</Label>
                                            <Select
                                                id="colleges"
                                                isMulti
                                                options={collegeOptions}
                                                value={selectedColleges}
                                                onChange={handleSelectedColleges}
                                                classNamePrefix="select2-selection"
                                                placeholder="Select eligible colleges"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="colleges">Eligible Branches</Label>
                                            <Select
                                                id="branches"
                                                isMulti
                                                options={branchOptions}
                                                value={selectedBranches}
                                                onChange={handleSelectedBranches}
                                                classNamePrefix="select2-selection"
                                                placeholder="Select eligible branches"

                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <Label htmlFor="colleges">Eligible Passout years</Label>
                                        <Select
                                            id="eligible-passout-year"
                                            isMulti
                                            options={eligiblePasoutYearsOptions}
                                            value={selectedEligibleYears}
                                            onChange={handleEligiblePassoutYears}
                                            classNamePrefix="select2-selection"
                                            placeholder="Select eligible Passout Years"
                                        />

                                    </Col>
                                </Row>


                                <Row>

                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="years">Mentors</Label>
                                            <Select
                                                id="mentors"
                                                isMulti
                                                options={mentorOptions}
                                                value={selectedMentors}
                                                onChange={handleMentors}
                                                classNamePrefix="select2-selection"
                                                placeholder="Select Mentors"
                                            />

                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="years">Support Mentors</Label>
                                            <Select
                                                id="supportMentors"
                                                isMulti
                                                options={supportMentorOptions}
                                                value={selectedSupportMentors}
                                                onChange={handleSupportMentors}
                                                classNamePrefix="select2-selection"
                                                placeholder="Select Support Mentors"
                                            />

                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="syllabus">Syllabus</Label>
                                            <AvField
                                                name="syllabus"
                                                type="file"
                                                className="form-control"
                                                id="syllabus"
                                                onChange={(e) => setSyllabus(e.target.files[0])}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label>
                                                Certifications
                                            </Label>

                                            {certifications.map((cert, index) => (
                                                <div key={index} className="d-flex align-items-center mb-2">
                                                    {/* Dropdown for certification names */}
                                                    <select
                                                        className="form-control me-2"
                                                        value={cert.name}
                                                        onChange={(e) => handleCertificationChange(index, e.target.value)}
                                                    >
                                                        <option value="">Select Certification</option>
                                                        {certificationOptions.map((c) => (
                                                            <option key={c._id} value={c.certification_name}>
                                                                {c.certification_name}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Preview logo */}
                                                    {cert.logo && (
                                                        <img
                                                            src={`${backendImgUrl}certification-icons/${cert.logo}`}
                                                            alt={cert.name}
                                                            style={{ width: "40px", height: "40px", objectFit: "contain" }}
                                                            className="me-2"
                                                        />
                                                    )}

                                                    {index > 0 && (
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => handleRemoveCertification(index)}
                                                        >
                                                            Remove
                                                        </Button>
                                                    )}
                                                </div>
                                            ))}

                                            <Button color="primary" size="sm" onClick={handleAddCertification}>
                                                Add Certification
                                            </Button>
                                        </div>
                                    </Col>

                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="years">Select Cashiers<span className="text-danger">*</span></Label>
                                            <Select
                                                id="eligible-passout-year"
                                                isMulti
                                                options={cashierOptions}
                                                value={selectedCashiers}
                                                onChange={handleSelectedCashiers}
                                                classNamePrefix="select2-selection"
                                                placeholder="Select Cashiers"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="terms">Term Fee Details <span className="text-danger">*</span></Label>
                                            {termFeeDetails.map((fee, index) => (
                                                <div key={index} className="border rounded p-2 mb-2">
                                                    <select
                                                        className="form-control mb-2"
                                                        value={fee.term_name}
                                                        onChange={(e) => handleTermFeeChange(index, "term_name", e.target.value)}
                                                    >
                                                        <option value="">Select Term</option>

                                                        {termNameOptions
                                                            .filter(option =>
                                                                // Show only unused terms OR the term already selected in this row
                                                                !termFeeDetails.some((t, i) => t.term_name === option.value && i !== index)
                                                            )
                                                            .map(option => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))
                                                        }
                                                    </select>

                                                    {/* <AvField
                                                        name={`termFeeDetails[${index}].amount`}
                                                        placeholder="Amount"
                                                        type="number"
                                                        className="form-control mb-2"
                                                        value={fee.amount}
                                                        onChange={(e) => handleTermFeeChange(index, "amount", e.target.value)}
                                                    /> */}
                                                    <AvField
                                                        name={`termFeeDetails[${index}].amount`}
                                                        placeholder="Amount"
                                                        type="number"
                                                        className="form-control mb-2"
                                                        value={fee.amount}
                                                        min="1"               // prevents negative & zero
                                                        step="1"              // prevents decimals
                                                        onKeyDown={(e) => {
                                                            const invalidKeys = ["-", "+", "e", "E", ".", ","];
                                                            if (invalidKeys.includes(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            let val = e.target.value;

                                                            // Remove decimals if pasted
                                                            val = val.replace(/\D/g, "");

                                                            // Prevent zero or empty
                                                            if (val === "" || Number(val) < 1) val = "";

                                                            handleTermFeeChange(index, "amount", val);
                                                        }}
                                                    />

                                                    <AvField
                                                        type="select"
                                                        name={`termFeeDetails[${index}].status`}
                                                        className="form-control mb-2"
                                                        value={fee.status}
                                                        onChange={(e) => handleTermFeeChange(index, "status", Number(e.target.value))}
                                                    >
                                                        <option value="">Select Status</option>
                                                        <option value={1}>Active</option>
                                                        <option value={0}>Inactive</option>
                                                    </AvField>

                                                    {/* <AvField
                                                        name={`termFeeDetails[${index}].endDate`}
                                                        type="date"
                                                        className="form-control"
                                                        value={fee.endDate}
                                                        onChange={(e) => handleTermFeeChange(index, "endDate", e.target.value)}
                                                        placeholder="Select End Date YYYY-MM-DD"
                                                    /> */}
                                                    {index > 0 && (
                                                        <Button color="danger" size="sm" onClick={() => removeTermFeeField(index)}>
                                                            Remove
                                                        </Button>
                                                    )}
                                                </div>
                                            ))}
                                            <Button color="primary" size="sm" onClick={addTermFeeField}>
                                                + Add Term Fee
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="registration-start-date">Registration Start Date <span className="text-danger">*</span></Label>
                                            <Flatpickr
                                                id="registration-start-date"
                                                className="form-control"
                                                value={registrationStartDate}
                                                onChange={(date) => setRegistrationStartDate(date[0] || null)}
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    minDate: "today"
                                                }}
                                                placeholder="Select Registration Start Date"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="registration-end-date">Registration End Date <span className="text-danger">*</span></Label>
                                            <Flatpickr
                                                id="registration-end-date"
                                                className="form-control"
                                                value={registrationEndDate}
                                                onChange={(date) => setRegistrationEndDate(date[0] || null)}
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    minDate: "today"
                                                }}
                                                placeholder="Select Registration End Date"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="course-start-date">Course Start Date <span className="text-danger">*</span></Label>
                                            <Flatpickr
                                                id="course-start-date"
                                                className="form-control"
                                                value={courseStartDate}
                                                onChange={(date) => setCourseStartDate(date[0] || null)}
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    minDate: "today"
                                                }}
                                                placeholder="Select Course Start Date"
                                            />

                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="course-end-date">Course End Date <span className="text-danger">*</span></Label>
                                            <Flatpickr
                                                id="course-end-date"
                                                className="form-control"
                                                value={courseEndDate}
                                                onChange={(date) => setCourseEndDate(date[0] || null)}
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    minDate: "today"
                                                }}
                                                placeholder="Select Course End Date"

                                            />


                                        </div>
                                    </Col>
                                </Row>


                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="description">Description</Label>
                                            <AvField
                                                tag="textarea"
                                                name="description"
                                                id="description"
                                                placeholder="Enter Description"
                                                className="form-control"
                                                value={description}
                                                onChange={handleDescription}          // Cleans text after input (Pasting)
                                                onKeyDown={blockInvalidTextKeys}      // Blocks invalid keys before input (Typing)
                                                style={{
                                                    resize: "none",
                                                    overflowY: "auto",
                                                    overflowX: "hidden",
                                                    whiteSpace: "pre-wrap"
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="note">Note</Label>
                                            <AvField
                                                tag="textarea"
                                                name="note"
                                                id="note"
                                                placeholder="Enter Note"
                                                className="form-control"
                                                value={note}
                                                onChange={handleNote}                 // Cleans text after input (Pasting)
                                                onKeyDown={blockInvalidTextKeys}      // Blocks invalid keys before input (Typing)
                                                style={{
                                                    resize: "none",
                                                    overflowY: "auto",
                                                    overflowX: "hidden",
                                                    whiteSpace: "pre-wrap"
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="status">
                                                Registration Status <span className="text-danger">*</span>
                                            </Label>
                                            <Select
                                                value={selectedRegistrationStatus}
                                                options={registrationStatusOptions}
                                                onChange={handleSelectedRegistrationStatus}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        <div className="mb-4">
                                            <Label htmlFor="status">
                                                Payment Status <span className="text-danger">*</span>
                                            </Label>
                                            <Select
                                                value={selectedStatus}
                                                options={statusOptions}
                                                onChange={handleSelectedStatus}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>

                                </Row>
                                <Button color="primary" type="submit">
                                    Submit
                                </Button>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default AddCourseRegistration;